import React from "react";
import { Link } from "react-scroll";
import Social from "./Social";
import { 
  MdEmail, 
  MdPhone, 
  MdLocationOn, 
  MdArrowForward 
} from "react-icons/md";

function Footer() {
  const currentYear = new Date().getFullYear();

  const navItems = [
    { name: "Početna", to: "hero" },
    { name: "O nama", to: "about" },
    { name: "Usluge", to: "services" },
    { name: "Kontakt", to: "contact" }
  ];

  const contactInfo = [
    { 
      icon: <MdEmail className="h-5 w-5 text-primary-600 group-hover:rotate-12 transition-transform duration-300" />,
      text: "info@luxenergy.hr",
      href: "mailto:info@luxenergy.hr",
      ariaLabel: "Send us an email"
    },
    { 
      icon: <MdPhone className="h-5 w-5 text-primary-600 group-hover:rotate-12 transition-transform duration-300" />,
      text: "+385 99 216 9652",
      href: "tel:+385992169652",
      ariaLabel: "Call us"
    },
    { 
      icon: <MdLocationOn className="h-5 w-5 text-primary-600 group-hover:rotate-12 transition-transform duration-300" />,
      text: "Vladimira Nazora 62",
      subText: "31542 Šljivoševci, Hrvatska",
      href: "https://maps.google.com/?q=Vladimira+Nazora+62,Šljivoševci,Hrvatska",
      ariaLabel: "Find us on Google Maps"
    }
  ];

  return (
    <footer className="bg-gradient-to-b from-white to-primary-50 relative">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-8 -right-8 w-64 h-64 bg-primary-100/30 rounded-full blur-3xl" />
        <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-primary-200/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 py-16 relative">
        {/* Grid Layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="col-span-2 md:col-span-1 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-primary-600">Lux</span>
              <span className="text-gray-800">Energy</span>
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Vaš partner za održivu energetsku budućnost. Inovativna rješenja za čistu energiju.
            </p>
          </div>

          {/* Quick Links */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">Poveznice</h4>
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-80}
                  className="text-sm text-gray-600 hover:text-primary-600 
                           transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  <span className="w-0 group-hover:w-2 h-px bg-primary-600 mr-0 
                                 group-hover:mr-2 transition-all duration-300"></span>
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">Kontakt</h4>
            <div className="space-y-4 text-sm text-gray-600">
              {contactInfo.map((item, index) => (
                item.href ? (
                  <a 
                    key={index}
                    href={item.href}
                    aria-label={item.ariaLabel}
                    className="flex items-start hover:text-primary-600 
                              transition-colors duration-300 group"
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    <span className="mr-3 mt-1 group-hover:scale-110 transition-all duration-300">
                      {item.icon}
                    </span>
                    <div className="flex flex-col">
                      <span className="group-hover:translate-x-1 transition-transform duration-300">
                        {item.text}
                      </span>
                      {item.subText && (
                        <span className="text-gray-500 text-xs mt-0.5 group-hover:translate-x-1 transition-transform duration-300">
                          {item.subText}
                        </span>
                      )}
                    </div>
                    <MdArrowForward className="h-4 w-4 ml-2 opacity-0 group-hover:opacity-100 
                                         group-hover:translate-x-1 transition-all duration-300" />
                  </a>
                ) : (
                  <div 
                    key={index}
                    className="flex items-start"
                  >
                    <span className="mr-3 mt-1">
                      {item.icon}
                    </span>
                    <div className="flex flex-col">
                      <span>{item.text}</span>
                      {item.subText && (
                        <span className="text-gray-500 text-xs mt-0.5">
                          {item.subText}
                        </span>
                      )}
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>

          {/* Social Media */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <h4 className="text-sm font-semibold text-gray-800 mb-4 uppercase tracking-wider">Pratite nas</h4>
            <Social />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200/50 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-600">
            <p className="mb-4 md:mb-0">© {currentYear} Lux Energy d.o.o. Sva prava pridržana.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;